import { SelectedInstanceType } from '@cast/types';
import { EdgeNodeArchitectureEnum } from '@cast/types-omni';

export const getSelectedInstance = ({
  availableInstances,
  instanceTypeName,
  availabilityZone,
}: {
  availableInstances: SelectedInstanceType[];
  instanceTypeName: string;
  availabilityZone: string;
}): SelectedInstanceType | undefined =>
  availableInstances?.find(
    (instance) =>
      instance.name === instanceTypeName && instance.zone === availabilityZone
  );

/**
 * Instance types API reports Kubernetes-style architecture (amd64/arm64),
 * while Omni expects its own enum. Unknown values fall back to X86_64
 * as it's the most common architecture.
 */
export const mapInstanceArchitectureToEdge = (
  selectedInstanceType: SelectedInstanceType
): EdgeNodeArchitectureEnum => {
  switch (selectedInstanceType.architecture) {
    case 'amd64':
      return EdgeNodeArchitectureEnum.X86_64;
    case 'arm64':
      return EdgeNodeArchitectureEnum.ARM64;
    default:
      return EdgeNodeArchitectureEnum.X86_64;
  }
};
